export const withdrawalStatuses = [
  {
    value: "PAID",
    label: "Paid",
    color: "bg-green-600 text-white",
  },
];
